// --- Core Vue imports ---
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// --- jQuery (make it global for legacy plugins) ---
import $ from 'jquery';
window.$ = window.jQuery = $;
// Owl JS immediately after jQuery
import 'owl.carousel'

// --- Global CSS (order matters: vendor first, then your overrides) ---
import '@/assets/css/bootstrap-datetimepicker.css';
import '@/assets/css/themify-icons.css';
import '@/assets/css/feather.css';
import '@/assets/css/emoji.css';
import '@/assets/css/lightbox.css';
import '@/assets/css/video-player.css';

// If you have vendor CSS folders, import them too, e.g. Owl
// import '@/assets/vendor/owl-carousel/css/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

// Your main stylesheet LAST so it can override vendor styles
import '@/assets/css/style.css';

// --- Vendor JS (order matters: libraries first, plugins after) ---
// Charts
import '@/assets/js/apexcharts.min.js';   // if this is ApexCharts UMD build
window.Apex = window.Apex || {};          // (Optional) Safety: define global Apex if your chart.js references it
import '@/assets/js/chart.js';            // if this is Chart.js UMD build

// jQuery plugins (require jQuery global above)
import '@/assets/js/jquery.easypiechart.min.js';
import '@/assets/js/lightbox.js';         // if it’s the jQuery lightbox plugin
import '@/assets/js/countdown.js';

// Any other vendor libs
import '@/assets/js/video-player.js';     // if this is a plain UMD/vanilla script
import '@/assets/js/plugin.js';           // legacy bundle from old site (optional)
import '@/assets/js/scripts.js';          // your old init file (optional)


// --- Boot Vue app ---
createApp(App)
  .use(router)
  .mount('#app');
